export const captureException = async (error, packageName, tags) => {
  // Re-introduce in EDM-9682
  return;
};